import { useQuery } from "@tanstack/react-query";

import { fetchFormato, fetchFormatos } from "@/lib/formatosDeSalida";

export const FORMATOS_KEY = ["formatos-salida"] as const;

export function useFormatosDeSalida() {
  return useQuery({ queryKey: FORMATOS_KEY, queryFn: fetchFormatos });
}

export function useFormatoDeSalida(id: number) {
  return useQuery({
    queryKey: [...FORMATOS_KEY, id],
    queryFn: () => fetchFormato(id),
    enabled: Number.isFinite(id),
  });
}
